export default __webpack_public_path__ + "static/media/death.02efcfa5.svg";